fx.ns("shared.popups", class ErrorAlbums extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Je n'ai pas réussi à récupérer vos photos"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Un problème technique est survenu. Veuillez essayer de nouveau dans quelques instants."), className:"text center"}));

        this.addFooterChild("close");
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onClose, this.closeBtn);
    }

    onClose()
    {
        super.onClose();

        this.data.event("show-editor")
    }
});